import { Link, useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui'
import { PATHS } from '@/app/router/paths'
import { AuthLayout, AuthLegalFooter, RustWordmark } from './AuthLayout'

export default function WelcomePage() {
  const navigate = useNavigate()
  return (
    <AuthLayout>
      <RustWordmark />
      <h1 className="auth-headline">Rust in je dag</h1>
      <p className="auth-subtitle">
        Een kalme plek voor je planning, herinneringen, ademhaling en dagboek. Alles overzichtelijk
        bij elkaar, op je eigen tempo.
      </p>
      <div style={{ width: '100%', marginTop: 8 }}>
        <Button variant="primary" size="lg" fullWidth onClick={() => navigate(PATHS.onboarding)}>
          Beginnen
        </Button>
      </div>
      <div className="auth-links">
        <Link to={PATHS.role}>Ik heb al een account</Link>
      </div>
      <AuthLegalFooter />
    </AuthLayout>
  )
}
